// List of country codes that require a national identifier field
export const NATIONAL_IDENTIFIER_COUNTRIES = ["BR", "AR", "IN", "MX"];

// List of country codes that require birth date field
export const BIRTH_DATE_COUNTRIES = ["BR"];

// List of country codes which do NOT require a region
export const NO_REGION_COUNTRIES = ["GB"];

// List of countries & regions to select from
export const COUNTRY_REGIONS = {
	"BR": [
		{ name: "Acre", code: "AC" },
		{ name: "Alagoas", code: "AL" },
		{ name: "Amapá", code: "AP" },
		{ name: "Amazonas", code: "AM" },
		{ name: "Bahia", code: "BA" },
		{ name: "Ceará", code: "CE" },
		{ name: "Distrito Federal", code: "DF" },
		{ name: "Espirito Santo", code: "ES" },
		{ name: "Goiás", code: "GO" },
		{ name: "Maranhão", code: "MA" },
		{ name: "Mato Grosso", code: "MT" },
		{ name: "Mato Grosso do Sul", code: "MS" },
		{ name: "Minas Gerais", code: "MG" },
		{ name: "Pará", code: "PA" },
		{ name: "Paraíba", code: "PB" },
		{ name: "Paraná", code: "PR" },
		{ name: "Pernambuco", code: "PE" },
		{ name: "Piauí", code: "PI" },
		{ name: "Rio de Janeiro", code: "RJ" },
		{ name: "Rio Grande do Norte", code: "RN" },
		{ name: "Rio Grande do Sul", code: "RS" },
		{ name: "Rondônia", code: "RO" },
		{ name: "Roraima", code: "RR" },
		{ name: "Santa Catarina", code: "SC" },
		{ name: "São Paulo", code: "SP" },
		{ name: "Sergipe", code: "SE" },
		{ name: "Tocantins", code: "TO" }
	],
	"CA": [
		{ name: "Alberta", code: "AB" },
		{ name: "British Columbia", code: "BC" },
		{ name: "Manitoba", code: "MB" },
		{ name: "New Brunswick", code: "NB" },
		{ name: "Newfoundland and Labrador", code: "NL" },
		{ name: "Nova Scotia", code: "NS" },
		{ name: "Northwest Territories", code: "NT" },
		{ name: "Nunavut", code: "NU" },
		{ name: "Ontario", code: "ON" },
		{ name: "Prince Edward Island", code: "PE" },
		{ name: "Quebec", code: "QC" },
		{ name: "Saskatchewan", code: "SK" },
		{ name: "Yukon", code: "YT" }
	],
	"MX": [
		{ name: "Aguascalientes", code: "AGS" },
		{ name: "Baja California", code: "BC" },
		{ name: "Baja California Sur", code: "BCS" },
		{ name: "Campeche", code: "CAM" },
		{ name: "Coahuila", code: "COA" },
		{ name: "Colima", code: "COL" },
		{ name: "Chiapas", code: "CHS" },
		{ name: "Chihuahua", code: "CHI" },
		{ name: "Distrito Federal", code: "DF" },
		{ name: "Durango", code: "DGO" },
		{ name: "Guanajuato", code: "GTO" },
		{ name: "Guerrero", code: "GRO" },
		{ name: "Hidalgo", code: "HGO" },
		{ name: "Jalisco", code: "JAL" },
		{ name: "Mexico", code: "MEX" },
		{ name: "Michoacan", code: "MIC" },
		{ name: "Morelos", code: "MOR" },
		{ name: "Nayarit", code: "NAY" },
		{ name: "Nuevo Leon", code: "NL" },
		{ name: "Oaxaca", code: "OAX" },
		{ name: "Puebla", code: "PEU" },
		{ name: "Queretaro", code: "QRO" },
		{ name: "Quintana Roo", code: "ROO" },
		{ name: "San Luis Potosi", code: "SLP" },
		{ name: "Sinaloa", code: "SIN" },
		{ name: "Sonora", code: "SON" },
		{ name: "Tabasco", code: "TAB" },
		{ name: "Tamaulipas", code: "TAM" },
		{ name: "Tlaxcala", code: "TLA" },
		{ name: "Veracruz", code: "VER" },
		{ name: "Yucatan", code: "YUC" },
		{ name: "Zacatecas", code: "ZAC" }
	],
	"US": [
		{ name: "Alabama", code: "AL" },
		{ name: "Alaska", code: "AK" },
		{ name: "Arizona", code: "AZ" },
		{ name: "Arkansas", code: "AR" },
		{ name: "California", code: "CA" },
		{ name: "Colorado", code: "CO" },
		{ name: "Connecticut", code: "CT" },
		{ name: "Delaware", code: "DE" },
		{ name: "District of Columbia", code: "DC" },
		{ name: "Florida", code: "FL" },
		{ name: "Georgia", code: "GA" },
		{ name: "Hawaii", code: "HI" },
		{ name: "Idaho", code: "ID" },
		{ name: "Illinois", code: "IL" },
		{ name: "Indiana", code: "IN" },
		{ name: "Iowa", code: "IA" },
		{ name: "Kansas", code: "KS" },
		{ name: "Kentucky", code: "KY" },
		{ name: "Louisiana", code: "LA" },
		{ name: "Maine", code: "ME" },
		{ name: "Maryland", code: "MD" },
		{ name: "Massachusetts", code: "MA" },
		{ name: "Michigan", code: "MI" },
		{ name: "Minnesota", code: "MN" },
		{ name: "Mississippi", code: "MS" },
		{ name: "Missouri", code: "MO" },
		{ name: "Montana", code: "MT" },
		{ name: "Nebraska", code: "NE" },
		{ name: "Nevada", code: "NV" },
		{ name: "New Hampshire", code: "NH" },
		{ name: "New Jersey", code: "NJ" },
		{ name: "New Mexico", code: "NM" },
		{ name: "New York", code: "NY" },
		{ name: "North Carolina", code: "NC" },
		{ name: "North Dakota", code: "ND" },
		{ name: "Ohio", code: "OH" },
		{ name: "Oklahoma", code: "OK" },
		{ name: "Oregon", code: "OR" },
		{ name: "Pennsylvania", code: "PA" },
		{ name: "Rhode Island", code: "RI" },
		{ name: "South Carolina", code: "SC" },
		{ name: "South Dakota", code: "SD" },
		{ name: "Tennessee", code: "TN" },
		{ name: "Texas", code: "TX" },
		{ name: "Utah", code: "UT" },
		{ name: "Vermont", code: "VT" },
		{ name: "Virginia", code: "VA" },
		{ name: "Washington", code: "WA" },
		{ name: "West Virginia", code: "WV" },
		{ name: "Wisconsin", code: "WI" },
		{ name: "Wyoming", code: "WY" }
	]
};
